import { useMessengerFactory } from "@faire/retailer/stores/MessengerFactory";

import { useInsiderNotificationType } from "./useInsiderNotificationType";
import { useRevampedDropdownData } from "./useRevampedDropdownData";

export const useHasAccountNotifications = () => {
  const { messengerStore } = useMessengerFactory(["messengerStore"]);
  const hasInsiderNotification = useInsiderNotificationType();
  const { reviewCount, numOfPendingOrders, newFollows } =
    useRevampedDropdownData();

  const revampedNotifications =
    reviewCount ||
    numOfPendingOrders ||
    newFollows ||
    hasInsiderNotification ||
    messengerStore.unreadConversationCount;

  return revampedNotifications;
};
